import { abandonBasket } from "../basket-v2/api/abandonBasket";
import { EventBasketType } from "./EventBasketType";

export function tryAbandonBasket(basketType?: EventBasketType): Promise<boolean> {
  if(basketType === "v2"){
    return abandonBasket();
  }
  return Promise.resolve(true);
}
